"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateToUTC = void 0;
/**
 *
 * @param dateString takes any format of the date as string
 * @returns returns always the same format of date (ex. May 10, 2023)
 */
var formatDateToUTC = function (dateString) {
    try {
        var formattedDate = new Date(dateString).toUTCString();
        return formattedDate;
    }
    catch (error) {
        console.error('An error occurred while formatting the date:', error);
        return dateString;
    }
};
exports.formatDateToUTC = formatDateToUTC;
//# sourceMappingURL=dateFormatters.js.map